import { useEffect, useState } from 'react'

import { getRequestRelatedRequestsCount } from '../../../../api'
import { useIsMountedRef } from '../../../../hooks'

import { REQUEST_PROFILE_RELATED_REQUESTS_COUNT_DEFAULT } from './useRequestProfileRelatedRequestsCount.constants'

export function useRequestProfileRelatedRequestsCount({
  canViewRelatedRequests,
  isArchived,
  requestId,
}) {
  const [relatedRequestsCount, setRelatedRequestsCount] = useState(
    REQUEST_PROFILE_RELATED_REQUESTS_COUNT_DEFAULT
  )

  const isMountedRef = useIsMountedRef()

  async function handleLoadRelatedRequestsCount() {
    if (!requestId || isArchived || !canViewRelatedRequests) {
      return null
    }

    return getRequestRelatedRequestsCount(requestId)
      .then(({ data }) => {
        if (isMountedRef.current) {
          setRelatedRequestsCount(data.count)
        }

        return data
      })
      .catch(() => {
        if (isMountedRef.current) {
          setRelatedRequestsCount(
            REQUEST_PROFILE_RELATED_REQUESTS_COUNT_DEFAULT
          )
        }

        return null
      })
  }

  useEffect(() => {
    handleLoadRelatedRequestsCount()
  }, [canViewRelatedRequests, isArchived, requestId])

  return { handleLoadRelatedRequestsCount, relatedRequestsCount }
}
